import type { Theme } from "@mui/material/styles";

export interface InvoicePdfPalette {
  /** Fill behind the line-item table's header row. */
  bandFill: string;
  /** Rule under each line-item row. */
  hairline: string;
}

/**
 * The PDF's colours, resolved to literals.
 *
 * Two constraints the rest of the app does not have. A react-pdf StyleSheet
 * cannot read a CSS custom property, so the values have to arrive already
 * resolved; and `PDFDownloadLink` renders the document through react-pdf's own
 * reconciler, which React context does not cross, so the resolve has to happen
 * on the DOM side and travel as a prop.
 *
 * Always the LIGHT set, never `palette.mode`: a PDF has no colour scheme, and
 * an admin working in dark mode would otherwise send a dark-banded invoice to a
 * customer who prints it on white paper. Same reason InvoicePreview pins its
 * ground to `--color-bg-preview-light`.
 */
export const buildInvoicePdfPalette = (theme: Theme): InvoicePdfPalette => {
  const tokens = theme.outpave?.tokens?.light ?? {};
  return {
    bandFill: tokens["color-bg-page"],
    hairline: tokens["color-border"],
  };
};
